var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.5C4.67337 21.5 0 12.169 0 11C0 9.831 4.67337 0.5 14 0.5C23.3266 0.5 28 9.831 28 11C28 12.169 23.3266 21.5 14 21.5ZM1.76269 11C2.08906 12.0784 6.12412 19.75 14 19.75C21.8759 19.75 25.9109 12.0784 26.2373 11C25.9109 9.92156 21.8759 2.25 14 2.25C6.12412 2.25 2.08906 9.92156 1.76269 11ZM14 17.125C10.6229 17.125 7.875 14.3775 7.875 11C7.875 7.6225 10.6229 4.875 14 4.875C17.3771 4.875 20.125 7.6225 20.125 11C20.125 14.3775 17.3771 17.125 14 17.125ZM14 6.625C11.5876 6.625 9.625 8.58763 9.625 11C9.625 13.4124 11.5876 15.375 14 15.375C16.4124 15.375 18.375 13.4124 18.375 11C18.375 8.58763 16.4124 6.625 14 6.625Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b80e243e771c8b5c122b4b613db4bb18.svg";
export { ForwardRef as ReactComponent };